@if (apiLoading$ | async) {
  <cx-spinner class="overlay"></cx-spinner>
}
@if (productCode) {
  <form [formGroup]="groupRuleCartForm!" (submit)="groupRuleAddToCart()">
    @if(!hideFields){
      @if (!isEmptyObject(product?.groupRuleAddonMealProduct)) {
        <section>
          <div class="row grp-background">
            <span class="grp-addon-header">{{ 'groupSalesPDP.mealAddon' | cxTranslate }}</span>
          </div>
          <div class="container">
            <div class="row grp-addon-product-desc">
              {{ product.groupRuleAddonMealProduct?.description }}
            </div>
            @if (product?.groupRuleAddonMealProduct?.variantOptions != undefined) {
              @for (option of product?.groupRuleAddonMealProduct?.variantOptions; track option) {
                <div class="row" style="margin-top: 20px;align-items: baseline;">
                  <div class="col grp-addon-variant" style="max-width: 25%;">{{ option.name }} :</div>
                  <div class="col grp-addon-variant" style="max-width: 10%;">{{ option.startingPrice?.formattedValue }}</div>
                  <div class="col">
                    <app-item-counter
                      [control]="$any(groupRuleCartForm?.get(option.code! + '#mealAddon'))"
                      (quantityChanged)="onGroupRuleQuantityChange($event, option.code! + '#mealAddon')"
                      [max]="option.maxQty"
                      [min]="option.minQty"
                      [allowZero]="true"
                    ></app-item-counter>
                    @if (stepperBtnDisabled(option.stock)) {
                      <small class="text-danger out-of-stock-label">{{ 'addToCart.outOfStock' | cxTranslate }}</small>
                    }
                    @if (!stepperBtnDisabled(option.stock)) {
                      <small class="group-type-age-label">
                        ({{ option.minQty }} ~ {{ option.maxQty }})
                      </small>
                    }
                  </div>
                </div>
              }
            } @else {
              <div class="grp-addon-prd-detail">
                <div class="grp-addon-product-name">{{ product.groupRuleAddonMealProduct?.name }} :</div>
                <div class="grp-addon-product-price">{{ product.groupRuleAddonMealProduct?.price?.formattedValue }}</div>
                <div>
                  <app-item-counter
                    [control]="$any(groupRuleCartForm?.get('mealAddon'))"
                    (quantityChanged)="onGroupRuleQuantityChange($event, product.groupRuleAddonMealProduct?.code!+'#mealAddon')"
                    [max]="product.maxQty ? +product.maxQty : this.getMaxNumber()"
                    [min]="+product.minQty!"
                    [allowZero]="true"
                  ></app-item-counter>
                  @if (stepperBtnDisabled(product.stock)) {
                    <small class="text-danger out-of-stock-label">{{ 'addToCart.outOfStock' | cxTranslate }}</small>
                  }
                  @if (!stepperBtnDisabled(product.stock)) {
                    <small class="group-type-age-label">
                      ({{ product.minQty }} ~ {{ product.maxQty }})
                    </small>
                  }
                </div>
              </div>
            }
          </div>
        </section>
      }
    }
    @if (!isEmptyObject(product?.groupRuleAddonProduct)) {
      <section class="grp-section-margin">
        <div class="row grp-background">
          @if(!hideFields){
            <span class="grp-addon-header">{{ 'groupSalesPDP.addonProd' | cxTranslate }}</span>
          }
          @else {
          <span class="grp-addon-header">{{ 'groupSalesPDP.addonProdUDX' | cxTranslate }}</span>
        }
      </div>
      <div class="container">
        <div class="row grp-addon-product-desc">
          {{ product.groupRuleAddonProduct?.description }}
        </div>
        @if (product?.groupRuleAddonProduct?.variantOptions != undefined) {
          @for (option of product.groupRuleAddonProduct?.variantOptions; track option) {
            <div class="row" style="margin-top: 20px;align-items: baseline;" >
              <div class="col grp-addon-variant" style="max-width: 25%;">{{ option.name }} :</div>
              <div class="col grp-addon-variant" style="max-width: 10%;">{{ option.startingPrice?.formattedValue }}</div>
              <div class="col">
                <app-item-counter
                  [control]="$any(groupRuleCartForm?.get(option.code! + '#addonProduct'))"
                  (quantityChanged)="onGroupRuleQuantityChange($event, option.code! + '#addonProduct')"
                  [max]="option.maxQty"
                  [min]="option.minQty"
                  [allowZero]="true"
                ></app-item-counter>
                @if (stepperBtnDisabled(option.stock)) {
                  <small class="text-danger out-of-stock-label">{{ 'addToCart.outOfStock' | cxTranslate }}</small>
                }
                @if (!stepperBtnDisabled(option.stock)) {
                  <small class="group-type-age-label">
                    ({{ option.minQty }} ~ {{ option.maxQty }})
                  </small>
                }
              </div>
            </div>
          }
        } @else {
          <div class="grp-addon-prd-detail">
            <div class="grp-addon-product-name">{{ product.groupRuleAddonProduct?.name }} :</div>
            <div class="grp-addon-product-price">{{ product.groupRuleAddonProduct?.price?.formattedValue }}</div>
            <div>
              <app-item-counter
                [control]="$any(groupRuleCartForm?.get('addonProduct'))"
                (quantityChanged)="onGroupRuleQuantityChange($event, product.groupRuleAddonProduct?.code!+'#addonProduct')"
                [max]="product.maxQty ? +product.maxQty : this.getMaxNumber()"
                [min]="+product.minQty!"
                [allowZero]="true"
              ></app-item-counter>
              @if (stepperBtnDisabled(product.stock)) {
                <small class="text-danger out-of-stock-label">{{ 'addToCart.outOfStock' | cxTranslate }}</small>
              }
              @if (!stepperBtnDisabled(product.stock)) {
                <small class="group-type-age-label">
                  ({{ product.minQty }} ~ {{ product.maxQty }})
                </small>
              }
            </div>
          </div>
        }
      </div>
    </section>
  }
  <section class="grp-section-margin">
    @if(product.dateSelectionRequired){
      <div class="row grp-background">
        <span class="grp-addon-header">{{ 'groupSalesPDP.visitDate' | cxTranslate }}</span>
      </div>
      <div class="container">
        <div class="grp-addon-prd-detail">
          @if (!this.usjfeature) {
            <div class="grp-addon-product-name required-field">{{ 'groupSalesPDP.visitDateDesc' | cxTranslate }}</div>
          }
          <div class="grp-addon-product-price">
            <mat-form-field appearance="fill">
              <mat-label>{{ 'pdp.datelabel' | cxTranslate }}</mat-label>
              <input
                matInput
                [min]="minDate"
                (dateChange)="dateSelected($event)"
                [matDatepicker]="dp"
                formControlName="groupRuleDatePicker"
                [matDatepickerFilter]="dateFilter"
                [value]="resetDate()"
                />
              <mat-datepicker-toggle matSuffix [for]="dp" (click)="onPickerToggle()"></mat-datepicker-toggle>
              <mat-datepicker #dp></mat-datepicker>
            </mat-form-field>
            @if (isLoadingDates) {
              <mat-spinner></mat-spinner>
            }
            <!-- shouldDisableDateSelection(): {{ shouldDisableDateSelection() }} -->
          </div>
          @if(product.timeSelectionRequired){
            <div class="grp-addon-product-name required-field">{{ 'pdp.selectVisitTimeNa' | cxTranslate }}</div>
            <div class="grp-addon-product-price">
              <mat-form-field appearance="fill">
                <mat-label></mat-label>
                <mat-select formControlName="timeSlotPicker" name="time" (selectionChange)="timeSlotSelected($event)"
                  [value]="getDefaultPerfomance() ">
                  @for (time of grpSalesTimeSlot; track time) {
                    <mat-option [value]="time">
                      {{ time }}
                    </mat-option>
                  }
                </mat-select>
              </mat-form-field>
              @if (isLoadingDates) {
                <mat-spinner></mat-spinner>
              }
            </div>
          }
        </div>
      </div>
    }
  </section>
  <mat-divider></mat-divider>
  <div class="action">
    <div class="total">
      <label>@if (this.usjfeature) {
        <span>{{ 'groupSalesPDP.total' | cxTranslate }}</span>
      }{{ grpSubTotal$ | async | currency: defaultCurrencyISO}}</label>
    </div>
    <div>
      <button type="submit" class="btn btn-primary btn-lg" [disabled]="isAddToCartDisabled">
        {{ 'groupSalesPDP.checkout' | cxTranslate }}
      </button>
    </div>
  </div>
</form>
}
